import { Link } from 'react-router-dom';

/**
 * Button component
 *
 * Props:
 *   variant: 'primary' | 'outline'  (default 'primary')
 *   href: external URL → renders <a>
 *   to: internal route → renders <Link>
 *   onClick: renders <button>
 *   children
 *   className: extra class names
 *   ...rest: passed to the underlying element
 */
function Button({ variant = 'primary', href, to, children, className = '', ...rest }) {
  const cls = `btn-${variant}${className ? ' ' + className : ''}`;

  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {children}
      </a>
    );
  }

  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
}

export default Button;
